import React, { BaseSyntheticEvent, useMemo } from "react";
import localStyles from "./styles.module.scss";
import Card from "../../../components/Card";
import icons from "../../../utils/icons";
import { copy } from "../../../utils/methods";
import Button from "../../../components/Button";
import translate from "../../../utils/translate";

interface Props {
  id: number;
  date: string;
  url: string;
  user: {
    username: string
  };
  files: {
    thumb_image: string | null
    id: number;
    origin_name: string;
    bb_link_to_file: string;
    temporary_link_to_file: string;
  }[];
  pre_orders: {
    id: number;
    user_id: number;
    name: string;
    hash: string;
    created_at: string;
    laravel_through_key: number;
  },
  tracknumber: string
}

const FilesListItem = ({date, files, id, url: link, user, pre_orders, tracknumber}: Props) => {

  const formattedDate: string = useMemo(() => {
    const dateOfCreation = new Date(date);
    if (isNaN(dateOfCreation?.getTime())) {
      return;
    }
    return dateOfCreation.toLocaleDateString().split('.').reverse().join('.') +
        ' ' + dateOfCreation.toLocaleTimeString();
  }, [date]);

  return (<Card className={localStyles.container} onClick={() => {
    window.open(link, '_blank')
  }}>
    <div><strong>#{id}</strong> | {user?.username}</div>
    <div className={localStyles.linkContainer}>

      <div className={'d-flex align-items-center'} style={{
        gap: 15
      }}>
        <Button
            click={(event: BaseSyntheticEvent) => copy(link, null, event)}
            id={'copy-link'}
            size={'middle'}
            background={'bg-primary'}
            type={'button'}
            text={translate('copy_link')}
            classes={localStyles.copyButton}
            appendBefore={<img className={localStyles.icon}
                               src={icons.copy_all}
                               alt="copyImg"
            />}
        />
      </div>
      <div onClick={event => event.stopPropagation()} style={{
        cursor: 'text'
      }}>
        <p>pre-order: <strong>{pre_orders?.name}</strong></p>
        <p>tracknumber: <strong>{tracknumber}</strong></p>
      </div>
      <div className={'d-flex justify-content-end'} style={{gap: 10}}>
        {(files ?? []).slice(0, 3).map(file =>
            <img loading='lazy' key={file?.id} width={50} height={50}
                 src={file.thumb_image ? file.thumb_image : (file?.bb_link_to_file ?? file?.temporary_link_to_file)}
                 alt={file?.origin_name}/>
        )}
      </div>
    </div>
    <p className={localStyles.date} onClick={event => event.stopPropagation()}>{formattedDate}</p>
  </Card>)
}

export default FilesListItem;
